import * as React from "react";
import HtmlTooltip from "./HtmlTooltip";
import { IconButton } from "@material-ui/core";
import { ReferenceField, TextField } from "react-admin";
import { Info } from "@material-ui/icons";
import { useAppDataProvider } from "../../../../dataprovider";
import { getSecureRandom } from "../../../../Helper/random";

export const RefNoField = props => {
  const [isStorageFeedOrder, setIsStorageFeedOrder] = React.useState(false);
  const [storageFeedOrderRefNo, setStorageFeedOrderRefNo] = React.useState(null);
  const dataProvider = useAppDataProvider();
  React.useEffect(() => {
    // checkStorageFeedOrder();
  }, [props?.record?.id]);
  // const checkStorageFeedOrder = () => {
  //   dataProvider
  //     .getList('eightwings', {
  //       pagination: { page: 1, perPage: 1 },
  //       sort: { field: 'id', order: 'DESC' },
  //       filter: { storageFeedRequestId__eq: props?.record?.id ?? 0 },
  //     })
  //     .then(result => {
  //       if (result?.data?.length > 0) {
  //         setIsStorageFeedOrder(true);
  //         setStorageFeedOrderRefNo(result.data[0]?.request?.refNo);
  //       } else {
  //         setIsStorageFeedOrder(false);
  //       }
  //     });
  // };
  return props?.record != null ? (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
      }}
    >
      <>{props?.record.refNo}</>
      {(props?.record.isRejectionOrder || props?.record.isReplenishmentRejectionOrder) && (
        <HtmlTooltip title={props?.record.isRejectionOrder ? "Rejection Order" : "Replenishment Rejection Order"}>
          <IconButton>
            <ReferenceField key={getSecureRandom()} source={"parentRejectionOrderId"} reference="pbhrequestorders">
              <TextField source="refNo" />
            </ReferenceField>
            <Info />
          </IconButton>
        </HtmlTooltip>
      )}
      {/* {isStorageFeedOrder && (
        <HtmlTooltip title={`Eight Wings Storage Feed Order ${storageFeedOrderRefNo}`}>
          <IconButton>
            <Info />
          </IconButton>
        </HtmlTooltip>
      )} */}
    </div>
  ) : (
    <></>
  );
};
